import template from "../storage/template.json";
export const {
	theme: {
		lightColor1,
		lightColor2,
		lightColor3,
		darkColor1,
		darkColor2,
		darkColor3,
		normalColor
	}
} = template;

export const headingStyle = {
	color: lightColor1,
	fontWeight: "bold" as "bold"
};

export const labelStyle = {
	color: lightColor1,
	fontWeight: "bold" as "bold"
};

export const formValidatorStyle = {
	display: "block",
	fontSize: 11
};

export const buttonStyle = {
	fontWeight: "bold" as "bold"
};
